import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Usuario } from '../page/usuario/usuario';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {
  token: any;

  apiURL: string = environment.apiBaseUrl + 'usuario';


  constructor(private http: HttpClient, private router: Router, public dataService: DataService) {
  }

  deslogar() {
    localStorage.clear();
    this.dataService.usuarioLogado = '';
    this.dataService.horaExpirarToken = '';
    this.dataService.logado = false;
    this.router.navigate(['login']);
  }

  userAutenticado() {
    this.token = localStorage.getItem('token');
    if (this.token !== null &&
      this.token.toString().trim() !== null) {
      this.dataService.usuarioLogado = localStorage.getItem('usuarioLogado');
      this.dataService.horaExpirarToken = localStorage.getItem('horaExpirarToken');
      this.dataService.logado = true;
      return true;
    } else {
      this.dataService.logado = false;
      return false;
    }
  }

  list(page: number, size: number): Observable<any> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  save(usuario: Usuario): Observable<Usuario> {
    return this.http.post<Usuario>(this.apiURL, usuario);
  }

  update(usuario: Usuario): Observable<any> {
    return this.http.put<Usuario>(`${this.apiURL}/${usuario.id}`, usuario);
  }

  getById(id: number) {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }

    buscarComFiltro(page: number, size: number, parametro: string, tipoFiltro: string) {
          const params = new HttpParams()
          .set('page', page.toString())
          .set('size', size.toString())
          .set('parametro', parametro.toString())
          .set('tipoFiltro', tipoFiltro.toString())
          ;

    return this.http.get<any>(`${this.apiURL}/consulta${params}`);
  }

}
